import { jsonProperty, Serializable, SerializationSettings } from 'ts-serializable';
import ComponentArrasteSolteQuestionAlternativa from './ComponentArrasteSolteQuestionAlternativa';

interface IComponentArrasteSolteQuestion {
    codigo: number;
    text: string;
    feedback: string;
    alternativas: ComponentArrasteSolteQuestionAlternativa[];
}

class ComponentArrasteSolteQuestion extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    @jsonProperty(String)
    text: string = '';

    @jsonProperty(String)
    feedback: string = '';

    alternativas: ComponentArrasteSolteQuestionAlternativa[] = [];

    fromJSON(json: IComponentArrasteSolteQuestion, settings?: Partial<SerializationSettings>): this {
        this.codigo = json.codigo;
        this.text = json.text;
        this.feedback = json.feedback;
        this.alternativas = json.alternativas;

        return this;
    }
}

export default ComponentArrasteSolteQuestion;
